export const BuildInfo = {timestamp:1771636757000}
